;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { TOUR_OVERLAY_GROUPS } from "@/features/onboarding-tours/orchestrator/tour-overlay-groups";
import { tourStep } from "@/features/onboarding-tours/orchestrator/tour-step-builder";
import {
	TOUR_TARGETS,
	tourSelector,
} from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { defineTour } from "@/features/onboarding-tours/registry/define-tour";
import { TourCategory } from "@/features/onboarding-tours/types/tour-category";

const workspaceViewRowTarget = tourSelector(TOUR_TARGETS.workspaceViewRow);
const addDashboardViewButtonTarget = tourSelector(
	TOUR_TARGETS.addDashboardViewButton,
);
const addDashboardViewCancelTarget = tourSelector(
	TOUR_TARGETS.addDashboardViewCancel,
);
const addDashboardViewGridTarget = tourSelector(
	TOUR_TARGETS.addDashboardViewGrid,
);
const addDashboardViewSubmitTarget = tourSelector(
	TOUR_TARGETS.addDashboardViewSubmit,
);
const editDashboardViewButtonTarget = tourSelector(
	TOUR_TARGETS.editDashboardViewButton,
);
const editDashboardViewSheetTarget = tourSelector(
	TOUR_TARGETS.editDashboardViewSheet,
);
const workspaceViewToggleTarget = tourSelector(
	TOUR_TARGETS.workspaceViewToggle,
);
const deleteDashboardViewButtonTarget = tourSelector(
	TOUR_TARGETS.deleteDashboardViewButton,
);
const deleteDashboardViewConfirmTarget = tourSelector(
	TOUR_TARGETS.deleteDashboardViewConfirm,
);

export const addDashboardViewTour = defineTour({
	buildSteps: () => [
		tourStep({
			content: "Browse available system views to add to your workspace.",
			data: {
				advanceOn: "target-click",
			},
			placement: "left",
			scrollBefore: addDashboardViewButtonTarget,
			target: addDashboardViewButtonTarget,
			title: "Add a view",
		}),
		tourStep({
			content:
				"Pick one or more views, then add them — or close the dialog when you are done.",
			data: {
				completeWhenTargetsClicked: [
					addDashboardViewSubmitTarget,
					addDashboardViewCancelTarget,
				],
				overlayGroup: TOUR_OVERLAY_GROUPS.addDashboardView,
			},
			effect: "openAddDashboardView",
			hideOverlay: true,
			placement: "top",
			target: addDashboardViewGridTarget,
			title: "Select views",
			waitForTarget: true,
		}),
	],
	catalog: { lockedLabel: "Edit permission required" },
	category: TourCategory.workspaceTeam,
	description: "Add system dashboard views to your workspace.",
	eligibility: { requiresDashboardEdit: true },
	id: "add-dashboard-view",
	launch: {
		startRoute: ({ workspaceId }) => `/${workspaceId}/settings?tab=workspace`,
	},
	tags: ["views", "dashboard", "add"],
	title: "Add a dashboard view",
});

export const editDashboardViewTour = defineTour({
	buildSteps: () => [
		tourStep({
			content:
				"Each row is a dashboard view in your workspace. Pick one to customize its visualizations.",
			data: {
				watchTargetClick: {
					selector: editDashboardViewButtonTarget,
					stepIndex: 2,
				},
			},
			placement: "right",
			scrollBefore: workspaceViewRowTarget,
			spotlightPadding: 8,
			target: workspaceViewRowTarget,
			title: "Choose a view",
		}),
		tourStep({
			content:
				"Open the editor for a view to change which visualizations are active.",
			data: {
				advanceOn: "target-click",
			},
			placement: "left",
			scrollBefore: editDashboardViewButtonTarget,
			target: editDashboardViewButtonTarget,
			title: "Edit a view",
		}),
		tourStep({
			content:
				"Toggle individual visualizations on or off for this dashboard view.",
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.editDashboardView,
			},
			effect: "openEditDashboardView",
			hideOverlay: true,
			placement: "left",
			target: editDashboardViewSheetTarget,
			title: "Visualization settings",
			waitForTarget: true,
		}),
	],
	catalog: { lockedLabel: "Edit permission required" },
	category: TourCategory.workspaceTeam,
	description: "Customize which visualizations are active in a dashboard view.",
	eligibility: { requiresDashboardEdit: true },
	id: "edit-dashboard-view",
	launch: {
		startRoute: ({ workspaceId }) => `/${workspaceId}/settings?tab=workspace`,
	},
	tags: ["views", "dashboard", "edit", "visualizations"],
	title: "Edit a dashboard view",
});

export const deleteDisableDashboardViewTour = defineTour({
	buildSteps: () => [
		tourStep({
			content:
				"Each row is a dashboard view in your workspace. You can disable or remove them from here.",
			data: {
				watchTargetClick: {
					selector: deleteDashboardViewButtonTarget,
					stepIndex: 3,
				},
			},
			placement: "right",
			scrollBefore: workspaceViewRowTarget,
			spotlightPadding: 8,
			target: workspaceViewRowTarget,
			title: "Choose a view",
		}),
		tourStep({
			content: "Activate or deactivate views without deleting them.",
			data: {
				watchTargetClick: {
					selector: deleteDashboardViewButtonTarget,
					stepIndex: 3,
				},
			},
			placement: "right",
			scrollBefore: workspaceViewToggleTarget,
			spotlightPadding: 8,
			target: workspaceViewToggleTarget,
			title: "Disable a view",
		}),
		tourStep({
			content: "Delete views you no longer need from the workspace.",
			data: {
				advanceOnNext: {
					effect: "openDeleteDashboardView",
					stepIndex: 3,
				},
				watchTargetClick: {
					selector: deleteDashboardViewButtonTarget,
					stepIndex: 3,
				},
			},
			placement: "left",
			scrollBefore: deleteDashboardViewButtonTarget,
			spotlightPadding: 8,
			target: deleteDashboardViewButtonTarget,
			title: "Remove a view",
		}),
		tourStep({
			content:
				"Click Delete to permanently remove this view from your workspace.",
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.deleteDashboardView,
			},
			effect: "openDeleteDashboardView",
			hideOverlay: true,
			placement: "top",
			target: deleteDashboardViewConfirmTarget,
			title: "Confirm deletion",
			waitForTarget: true,
		}),
	],
	catalog: { lockedLabel: "Manage views permission required" },
	category: TourCategory.workspaceTeam,
	description:
		"Disable views temporarily or remove them from your workspace entirely.",
	eligibility: { requiresDashboardManage: true },
	id: "delete-disable-dashboard-view",
	launch: {
		startRoute: ({ workspaceId }) => `/${workspaceId}/settings?tab=workspace`,
	},
	tags: ["views", "dashboard", "delete", "disable", "remove"],
	title: "Delete or disable a dashboard view",
});
